import { useMemo } from "react";

import { getOffPlatformBookingPendingUrl } from "utils";

import { useSwrFetch } from "./useSwrFetch";

export interface PendingOffPlatformBooking {
  carrier_email: string | null;
  carrier_company_name: string | null;
  price: string;
  currency: string;
  quoting_unit_of_measure: UnitOfMeasureType;
  loads_booked: number | null;
  created_at: string;
}

interface PendingOffPlatformBookingResponse {
  pending: PendingOffPlatformBooking | null;
}

interface UseOffPlatformBookingPendingProps {
  shipmentId: number | undefined;
}

/*
The server decides whether a report is pending (latest, unresolved, shipment
ACTIVE), so the client only renders what it is given.
*/
export function useOffPlatformBookingPending(
  props: UseOffPlatformBookingPendingProps,
) {
  const { shipmentId } = props;

  const url = useMemo(
    () =>
      shipmentId !== undefined
        ? getOffPlatformBookingPendingUrl(shipmentId)
        : null,
    [shipmentId],
  );

  const { data, error } = useSwrFetch<PendingOffPlatformBookingResponse>({
    url,
    errorMessage: "Failed to fetch the pending off-platform booking",
  });

  return {
    pendingOffPlatformBooking: data?.pending ?? null,
    error,
  };
}
